import { 
  ResponseError,
} from '@backstage/errors';


export interface EpDevPApiError {
  readonly url: string;
  readonly status: number;
  readonly statusText: string;
  readonly body: any;
}

class EpDevPErrorUtils {
  
  public isNotFoundError(e: any): boolean {
    if(e instanceof ResponseError && e.cause.name === 'NotFoundError') return true;
    return false;
  }

  public isApiError(e: any): boolean {
    if(e instanceof ResponseError && e.cause.name === 'ApiError') return true;
    return false;
  }

  public getEpDevPApiError(e: any): EpDevPApiError | undefined {
    if(this.isApiError(e)) {
      if(e.cause === undefined) return undefined;
      return {
        url: e.cause.url || 'undefined' ,
        status: e.cause.status || '500',
        statusText: e.cause.statusText || 'undefined',
        body: e.cause.body || {}
      }; 
    } else return undefined;
  }
}

export default new EpDevPErrorUtils();
